/**
 *
 * AgreementListDxGridContainer
 *
 * 
 */

import React from 'react';
import PropTypes from 'prop-types';

class AgreementListDxGridContainer extends React.PureComponent {

  render() {
    const { component, parentId, height, dialogName, name } = this.props;

    return React.cloneElement(component, {
      name,
      parentId,
      height,
      dialogName,
    });
  }
}

AgreementListDxGridContainer.propTypes = {
  component: PropTypes.node.isRequired,
};

export default AgreementListDxGridContainer
